var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('v-sheet',{staticClass:"py-10 pl-4 pr-16 transparent"},[_c('span',{staticClass:"text-h5 title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }